module.exports = __webpack_public_path__ + "img/pdf.70df4656.png";